import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

function Loader({ color }) {
  return <CircularProgress style={{ color: color || "#ffffff" }} size={20} />;
}

export default React.memo(Loader);
